import { gql } from "@apollo/client";

const USER_TOURNAMENTS_LIST = gql`
  query userTournaments($user: Int) {
    userTournaments(user: $user) {
      id
      title
      logo
      league {
        league {
          sports {
            id
            title
          }
        }
      }
      tournamentCategory {
        category {
          name
          id
        }

        id
      }
      country
      startDate
      endDate
      entryDeadline
      timeZone
      status
    }
  }
`;

export default USER_TOURNAMENTS_LIST;
